<template>
  <div class="careers">
    <div class="wrapper">
      <LabeledTitle :content="content.hero" :noanimation="true" />
    </div>

    <div class="wrapper">
      <div class="intro__text">
        <IntroText
          :content="content.intro.htmltext"
          round="Jump to the job list"
          class="services__intro"
          @click.prevent="scroll('jobsList')"
        />
      </div>
      <hr />
    </div>

    <!-- <Loners :content="content.loners" class="services__intro" /> -->
    <List :content="content.loners" class="list--careers" />

    <Castle
      :config="{
        isConfigurable: false,
        scrollIn: true,
        rotation: true,
        colors: {
          primary,
          secondary,
        },
      }"
      class="careers__castle-top"
    />
    <Tldr :content="content.loners"></Tldr>

    <NaturalLight :content="content.light"></NaturalLight>

    <Castle
      :config="{
        isConfigurable: false,
        scrollIn: true,
        rotation: true,
        reversed: true,
        colors: {
          primary,
          secondary,
        },
      }"
      class="careers__castle-top"
    />
    <Tldr :content="content.light"></Tldr>

    <SharedValues
      :class="'shared__values'"
      :content="content.values"
    ></SharedValues>

    <JobsList :content="content.jobsList"></JobsList>

    <div class="wrapper">
      <hr />
      <UiCta :content="content.cta" class="m-d" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, onUnmounted, ref } from 'vue'
import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

import IntroText from '@/components/ui/IntroText.vue'
import LabeledTitle from '@/components/ui/LabeledTitle.vue'
import UiCta from '@/components/ui/Cta.vue'

import Castle from '@/components/castle/Castle.vue'

import List from '@/components/services/List.vue'
// import Loners from '@/components/careers/Loners.vue'
import NaturalLight from '@/components/careers/NaturalLight.vue'
import SharedValues from '@/components/careers/SharedValues.vue'
import JobsList from '@/components/careers/JobsList.vue'

import Tldr from '@/components/careers/Tldr.vue'

import { Color } from 'three'
gsap.registerPlugin(ScrollToPlugin)

const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  noanimation: {
    type: Boolean,
    required: false,
  },
})

const primary = ref()
const secondary = ref()
const scroll = (id: string) => {
  gsap.to(window, {
    scrollTo: `#${id}`,
    duration: 3,
    ease: 'power4.out',
  })
}
onBeforeMount(() => {
  primary.value = new Color(props.content.colors.foreground)
  secondary.value = new Color(props.content.colors.background)
})

onUnmounted(() => {
  document.body.classList.remove('pop-up-open')
})
</script>

<style>
.pop-up-open {
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
.careers {
  overflow: hidden;
}

:deep {
  .single-blog__polaroid {
    @include fluid(
      margin-bottom,
      (
        xxs: 40px,
        xxl: 80px,
      )
    );
  }

  // prettier-ignore
  .picture-outer:not(.list--careers .picture-outer, .pop-up .picture-outer, .natural__images .picture-outer) {
    position: absolute;
    width: 50rem;
    max-width: 50rem;
  }

  .labeled-title-outer span[data-position='second'] {
    margin-left: auto;
  }

  .text--big {
    @include fluid(
      font-size,
      (
        xxs: 16px,
        xxl: 30px,
      )
    );
    @include fluid(
      line-height,
      (
        xxs: 25px,
        xxl: 40px,
      )
    );

    @include mq(m) {
      width: col(6);
    }
  }

  .services__intro {
    @include fluid(
      padding-bottom,
      (
        xxs: 20px,
        xxl: 80px,
      )
    );

    p {
      @include fluid(
        font-size,
        (
          xxs: 20px,
          xxl: 30px,
        )
      );
      @include fluid(
        line-height,
        (
          xxs: 30px,
          xxl: 40px,
        )
      );
    }
  }

  .intro__text {
    @include fluid(
      margin-bottom,
      (
        xxs: 20px,
        xxl: 80px,
      )
    );

    display: flex;

    @include mq($until: s) {
      flex-direction: column;
    }
  }
}

:deep(.list--careers) {
  .list__item__count {
    display: none;
  }

  .list__title {
    @include mq(s, nav) {
      margin-bottom: 40px;
    }
  }

  .picture-outer {
    @include mq(nav) {
      min-width: 500px;
      max-width: 500px;
    }
  }

  .list__item__images {
    @include mq(nav) {
      bottom: -150px;
      left: -51px;
    }

    @include mq(xl) {
      bottom: -200px;
      left: 124px;
    }
  }

  .list__item__text {
    @include mq(nav) {
      width: 40%;
    }
  }

  @include mq(nav) {
    .list__item-content {
      flex-direction: row;
      justify-content: flex-end;
    }
  }
}

:deep(.list__item.is-reversed) {
  @include mq(nav) {
    margin-top: 400px;

    .list__item-content {
      justify-content: flex-start;
    }

    .list__item__text {
      margin-left: 0;
    }

    .list__item__images {
      right: -110px;
      bottom: 0;
      left: inherit;

      .list__item__image {
        right: 0;
      }

      @include mq(xl) {
        right: 0;
      }
    }
  }
}

.careers__castle-top {
  min-height: 50rem;
  pointer-events: none;
}
</style>
